/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Phase_PrepareInputs */

const en_directory_submit_enrich_phase_prepare = /** @type {(inputs: Directory_Submit_Enrich_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare`)
};

const zh_directory_submit_enrich_phase_prepare = /** @type {(inputs: Directory_Submit_Enrich_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备`)
};

/**
* | output |
* | --- |
* | "Prepare" |
*
* @param {Directory_Submit_Enrich_Phase_PrepareInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_phase_prepare = /** @type {((inputs?: Directory_Submit_Enrich_Phase_PrepareInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Phase_PrepareInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_phase_prepare(inputs)
	return zh_directory_submit_enrich_phase_prepare(inputs)
});
export { directory_submit_enrich_phase_prepare as "directory.submit.enrich.phase.prepare" }